import './assets/styles/main.css';
import Alpine from 'alpinejs';

// Docs entry point also uses Alpine directives in shared partials.
window.Alpine = Alpine;
Alpine.start();
